import * as React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../../lib/utils';
import { motion } from 'framer-motion';

// Variant for gradient layers
const gradientLayer = cva('home', {
  variants: {
    color: {
      blue: 'blue-graident',
      orange: 'orange-graident',
    },
  },
});

export function LightRays({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('bg-holder-2shadow-fly-animation absolute inset-0 rounded-2xl overflow-hidden', className)}
      {...props}
    >
        <motion.div
          className="absolute inset-0"
          style={{
            backgroundImage: 'url("/beautiful-bg.png")',
            backgroundSize: '80%', // creates smooth motion
            backgroundRepeat: 'no-repeat',
            backgroundPosition: '0% 0%',
          }}
          animate={{
            backgroundPosition: ['0% 0%', '100% 100%'],
          }}
          transition={{
            duration: 8,
            repeat: Infinity,
            repeatType: 'reverse',
          }}
        />
      </div>
  );
}

export function LightRays1({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('bg-holder-line-shadow fixed inset-0 pointer-events-none select-none -z-10', className)}
      {...props}
    >
      <div className="absolute w-[480px] h-[680px] rotate-[80deg] -top-[540px] left-[250px] bg-[radial-gradient(rgba(83,196,255,0.85)_0%,rgba(43,166,255,0)_100%)] blur-[110px]" />
      <div className="absolute w-[110px] h-[400px] -rotate-[20deg] -top-[280px] left-[350px] bg-[radial-gradient(rgba(83,196,255,0.85)_0%,rgba(43,166,255,0)_100%)] mix-blend-overlay opacity-60 blur-[60px]" />
      <div className="absolute w-[400px] h-[370px] -top-[350px] left-[200px] bg-[radial-gradient(rgba(83,196,255,0.85)_0%,rgba(43,166,255,0)_100%)] mix-blend-overlay opacity-60 blur-[21px]" />
      <div className="absolute w-[330px] h-[370px] -top-[330px] left-[50px] bg-[radial-gradient(rgba(83,196,255,0.85)_0%,rgba(43,166,255,0)_100%)] mix-blend-overlay opacity-50 blur-[21px]" />
      <div className="absolute w-[110px] h-[400px] -rotate-[40deg] -top-[280px] -left-[10px] bg-[radial-gradient(rgba(83,196,255,0.85)_0%,rgba(43,166,255,0)_100%)] mix-blend-overlay opacity-80 blur-[60px]" />
    </div>
  );
}

export function LightRays2({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('bg-holder-2shadow !h-[150%]', className)}
      style={{
        width: '100%',
        overflow: 'hidden',
        zIndex: -1,
        opacity: 0.8,
        willChange: 'transform',
        transform:
          'translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)',
        transformStyle: 'preserve-3d',
        flexFlow: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        maxWidth: '1500px',
        height: '80%',
        marginLeft: 'auto',
        marginRight: 'auto',
        display: 'flex',
        position: 'absolute',
        inset: 0,
      }}
      {...props}
    >
      <div
        className={gradientLayer({ color: 'blue' })}
        style={{
          opacity: 1,
          transform:
            'translate3d(0%, 0%, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)',
          transformStyle: 'preserve-3d',
        }}
      />
      <div
        className={gradientLayer({ color: 'orange' })}
        style={{
          opacity: 1,
          transform:
            'translate3d(0%, 0%, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)',
          transformStyle: 'preserve-3d',
        }}
      />
    </div>
  );
}
